import { cn } from '@/lib/utils';

interface Option {
  value: string;
  label: string;
}

interface Props {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function FilterChipRow({ options, value, onChange, className }: Props) {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={cn(
              'inline-flex items-center min-h-9 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-all border focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-active-gold/60',
              active
                ? 'bg-active-gold/15 text-active-gold border-active-gold/50 font-medium shadow-[0_0_0_1px_hsl(var(--active-gold)/0.15)]'
                : 'bg-white/[0.05] text-foreground/85 border-white/[0.06] hover:bg-white/[0.08] hover:text-foreground active:scale-[0.97]'
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
